import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
// import { AngularReactBrowserModule } from "@angular-react/core"; // Commented out - incompatible with Angular 19
import { HpOidcClientModule } from "@upmc-healthplan-npm/oidc-client";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { MainModule } from "./main/main.module";
import { httpInterceptorProviders } from "./interceptors/http-interceptors-providers";
import { LoginComponent } from "./login/login.component";
import { resolveOauth, resolveApplicationInsights } from "./resolveOauth";
import { AppInsightsModule } from "./app-insights/app-insights.module";
import { RouteEventsService } from "./shared/services/route-events/route-events.service";
import { UnauthorizedComponent } from "./unauthorized/unauthorized.component";
import { SharedModule } from "./shared/shared.module";
import { SignOutComponent } from "./sign-out/sign-out.component";
import { NgIdleModule } from "@ng-idle/core";
import { StartNgIdleService } from "./shared/services/ng-idle-startup/start-ng-idle.service";
import { LogoutComponent } from "./logout/logout.component";
import { EpPopupComponent } from "./shared/components/ep-popup/ep-popup.component";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    UnauthorizedComponent,
    SignOutComponent,
    LogoutComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MainModule,
    HpOidcClientModule.forRoot(resolveOauth),
    AppInsightsModule.forRoot(resolveApplicationInsights),
    SharedModule,
    NgIdleModule.forRoot(),
  ],
  providers: [
    httpInterceptorProviders,
    RouteEventsService,
    StartNgIdleService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {
  constructor(private startUp: StartNgIdleService) {
    this.startUp.setIdleCountdown();
  }
}
